import { render, staticRenderFns } from "./agreement-modal.vue?vue&type=template&id=55022c42&scoped=true&"
import script from "./agreement-modal.vue?vue&type=script&lang=js&"
export * from "./agreement-modal.vue?vue&type=script&lang=js&"
import style0 from "./agreement-modal.vue?vue&type=style&index=0&id=55022c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55022c42",
  null
  
)

export default component.exports